import { Switch } from "antd";
import dayjs from "dayjs";
import { useCallback, useState } from "react";
import Icon from "react-material-symbols/rounded";
import Alert from "shared/components/Alert";
import Input from "shared/components/Input";
import format from "string-template";
import { DATE_FORMAT } from "utils/constants";
import { bindDateInputProps } from "utils/helpers/input";

export const step = { CONTRACT: "CONTRACT" };

const Contract = ({ index, translation, values, ...formProps }) => {
  const [pickerValue, setPickerValue] = useState(dayjs());
  const [showInfo, setShowInfo] = useState(false);
  const checkExpired = useCallback(({ issuanceDate, isRia }) => {
    const minIssuanceDate = dayjs()
      .startOf("day")
      .add(isRia ? 30 : 1, "days");
    const expired = dayjs(issuanceDate).isBefore(minIssuanceDate);
    return expired;
  }, []);

  return (
    <div className="contact-stepper" key={step.CONTRACT}>
      <div className="contact-stepper__header">
        <div className="contact-stepper__header--counter">
          <span>{index}</span>
        </div>
        <div className="contact-stepper__header--content">
          <h1 className="contact-stepper__header--content--title">
            <span>
              {translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].TITLE}
            </span>
          </h1>
          <p className="contact-stepper__header--content--description">
            {translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].DESCRIPTION}
          </p>
        </div>
      </div>
      <div className="contact-stepper__content">
        {checkExpired({
          issuanceDate: values?.contract?.issuanceDate,
          isRia: values.ria,
        }) && (
          <Alert
            showIcon
            type="error"
            message={
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].INVALID_DATE
            }
            description={format(
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT]
                .INVALID_ISSUANCE,
              {
                date: dayjs()
                  .add(values.ria ? 30 : 0, "days")
                  .format(DATE_FORMAT),
              }
            )}
          />
        )}
        <div className="contact-stepper__content--radio">
          <Icon
            className="contact-stepper__content--radio--icon"
            icon="change_circle"
            size={22}
          />
          <span className="contact-stepper__content--radio--title">
            {
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM.CONTRACT
                .LABEL
            }
          </span>
          <Switch
            className="contact-stepper__content--radio--switch button__switch"
            checkedChildren={
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM.CONTRACT
                .OPTIONS.YES
            }
            unCheckedChildren={
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM.CONTRACT
                .OPTIONS.NO
            }
            defaultChecked={values.ria}
            onChange={(value, _) => {
              formProps.setFieldValue("ria", value);
              if (
                value &&
                checkExpired({
                  issuanceDate: values?.contract?.issuanceDate,
                  isRia: value,
                })
              ) {
                setShowInfo(true);
                formProps.setFieldValue(
                  "contract.issuanceDate",
                  dayjs().add(1, "M").toDate()
                );
              }
              setPickerValue(value ? dayjs().add(1, "M") : dayjs());
            }}
          />
        </div>
        <Input
          icon={<Icon icon="cake" size={22} />}
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM.START_DATE
              .LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM.START_DATE
              .PLACEHOLDER
          }
          type="date"
          variant="simple"
          format={DATE_FORMAT}
          disabledDate={(current) =>
            current && values.ria
              ? current < dayjs().startOf("day").add(1, "M")
              : current < dayjs().startOf("day").add(1, "day")
          }
          defaultPickerValue={pickerValue}
          {...bindDateInputProps({
            name: "contract.issuanceDate",
            values,
            ...formProps,
          })}
        />
        <>
          {showInfo && (
            <Alert
              showIcon
              type="info"
              message={format(
                translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT]
                  .INVALID_ISSUANCE,
                {
                  date: dayjs()
                    .add(values.ria ? 30 : 0, "days")
                    .format(DATE_FORMAT),
                }
              )}
            />
          )}
        </>
        <div className="contact-stepper__content--radio">
          <Icon
            className="contact-stepper__content--radio--icon"
            icon="social_distance"
            size={22}
          />
          <span className="contact-stepper__content--radio--title">
            {
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM
                .CONTRACT_TYPE.LABEL
            }
          </span>
          <Switch
            className="contact-stepper__content--radio--switch button__switch"
            checkedChildren={
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM
                .CONTRACT_TYPE.OPTIONS.YES
            }
            unCheckedChildren={
              translation.TEMPLATES.CONTACT.STEPS[step.CONTRACT].FORM
                .CONTRACT_TYPE.OPTIONS.NO
            }
            onChange={(value, _) => {
              formProps.setFieldValue("fields.twoTimesSale", value);
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default Contract;
